var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingCheckout = function SvgShoppingCheckout(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7a35afa9-d73b-4165-ac2a-6a395003d252",
    "data-name": "ICON",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "738d90cc-b5db-4a93-a991-e801889dc891",
    "data-name": "Shopping_trolley_ic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "985f6ec8-4f32-42d1-815e-6cebd9073ad7",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "1f6ebadf-54e7-4d01-a908-9253a4dbbc5b",
    "data-name": "<Pfad>",
    cx: 88,
    cy: 152,
    r: 12,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "ecc8a577-dd4f-4f0c-b396-f5cf0d6e15f7",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ee4b6617-6602-4566-a230-435aad3d4239",
    "data-name": "<Pfad>",
    cx: 136,
    cy: 152,
    r: 12,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "20 28 46 28 75 116 149 116 172 44 51.27 44",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCheckout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-checkout.fe2bf8b5.svg";
export { ForwardRef as ReactComponent };